import { render } from "./WebsiteInsight.vue?vue&type=template&id=3ed9d87f&scoped=true"
import script from "./WebsiteInsight.vue?vue&type=script&lang=js"
export * from "./WebsiteInsight.vue?vue&type=script&lang=js"

import "./WebsiteInsight.vue?vue&type=style&index=0&id=3ed9d87f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed9d87f"]])

export default __exports__